import {
  Getters,
  Mutations,
  Actions,
  Module,
  createMapper
} from 'vuex-smart-module'
import ImportProcessAPI from '@/components/routes/import/import-process/helpers/requests'

class ImportLogState {
  importStatus: any = {}
  importState: string | null = null
  importLog = ''
}

class ImportLogGetters extends Getters<ImportLogState> {}

class ImportLogMutations extends Mutations<ImportLogState> {
  setImportStatus(importStatus: any) {
    this.state.importStatus = importStatus
  }
  setImportState(importState: string | null) {
    this.state.importState = importState
  }
  pushImportLog(logEntry: string) {
    this.state.importLog += logEntry
  }
  clearImportLog() {
    this.state.importLog = ''
  }
}

class ImportLogActions extends Actions<
  ImportLogState,
  ImportLogGetters,
  ImportLogMutations,
  ImportLogActions
> {
  async fetchImportStatus() {
    const response = await ImportProcessAPI.getImportStatus()
    this.mutations.setImportStatus(response.data)
  }
}

export const importLog = new Module({
  state: ImportLogState,
  getters: ImportLogGetters,
  mutations: ImportLogMutations,
  actions: ImportLogActions
})

export const importLogMapper = createMapper(importLog)
